export default {
    grayBackground: 'grayBackground',
    small:          'small',
};